import { defaultSelectedCustomer } from './state'

export function getProducts(state,payload){
	state.products = payload;
}
export function getBranchsWare(state,payload){
	// this.$store.dispatch("listproducts/getBranchsWare");
	state.branchsWare= payload;
}


// WEBPACK FOOTER //
// ./src/modules/listproducts/mutations.js